module.exports = __webpack_public_path__ + "mo.svg?d4ec13b60fa71b9504b8330d8ba8bed9";